import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
} from "@mui/material";
import { Icon } from "@iconify/react";
import CloseIcon from "@mui/icons-material/Close";

import Logo from "../assets/images/Logo/FB and X Profil.png";

const RequiredDocumentsDialog = ({ open, onClose, onContinue }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const docList = [
    {
      title: "Passport-Size Photograph",
      details: [
        "Neutral facial expression (no smiling broadly).",
        "Eyes open, facing the camera directly.",
        "Plain light-colored background.",
        "No head coverings (except for religious purposes).",
        "No shadows, reflections, or accessories obstructing face.",
      ],
    },
    {
      title: "Passport Data Page",
      details: ["Clear image or scanned copy of the photo ID page."],
    },
    {
      title: "DCPJ Police Clearance Certificate",
      details: ["Required for Haiti residents only."],
    },
    {
      title: "Immunization Record (Optional)",
      details: [
        "Valid COVID-19 vaccine record.",
        "Yellow Fever certificate.",
        "Any other official immunization record.",
      ],
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "12px",
          minWidth: isSmallScreen ? "90%" : "600px",
        },
      }}
    >
      <DialogTitle
        sx={{
          p: "12px 24px",
          borderBottom: "1px solid #dee2e6",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img
            src={Logo}
            alt="Logo"
            style={{ width: "50px", borderRadius: "4px" }}
          />
          <h3 className="mb-0">Required Documentation</h3>
        </Box>
        <IconButton
          size="small"
          onClick={onClose}
          sx={{ color: "var(--bs-gray-700)" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className="pt-3" sx={{ p: 3 }}>
        {docList.map((doc, index) => (
          <Box
            key={index}
            sx={{
              mb: 2,
              p: 2,
              bgcolor: "#f8f9fa",
              border: "1px solid #dee2e6",
              borderRadius: 2,
            }}
          >
            <h4>
              {index + 1}. {doc.title}
            </h4>
            <ul className="mb-0 ps-3">
              {doc.details.map((detail, i) => (
                <li key={i} className="d-flex gap-2 align-items-center">
                  <Icon
                    icon="stash:circle-solid"
                    width="12"
                    height="12"
                    style={{ color: "#15978a" }}
                  />
                  {detail}
                </li>
              ))}
            </ul>
          </Box>
        ))}
      </DialogContent>

      <DialogActions sx={{ p: "12px 24px", borderTop: "1px solid #dee2e6" }}>
        <Button variant="outlined" onClick={onClose}>
          Close
        </Button>
        <Button
          variant="contained"
          onClick={onContinue}
          sx={{
            backgroundColor: "#15978a",
            "&:hover": { backgroundColor: "#0d6b61" },
          }}
        >
          Continue to Application
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RequiredDocumentsDialog;
